<template>
  <Button
    severity="danger"
    icon="pi pi-trash"
    size="small"
    variant="text"
    @click="destroy()"
  />

  <Toast />
</template>

<script lang="ts" setup>
const props = defineProps({
  taskId: String,
})
const emit = defineEmits(['refresh'])
const toast = useToast()
const { deleteTask } = useTasks()
const isLoading = ref(false)

const destroy = async () => {
  isLoading.value = true
  if (confirm('Are you sure?')) {
    const { data, error } = await deleteTask(props.taskId)

    if (error) {
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to delete task',
        life: 3000,
      })
      return
    }
    else {
      toast.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Successfully deleted task',
        life: 3000,
      })
    }

    emit('refresh')
  }
}
isLoading.value = false
</script>
